var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card-footer" }, [
      _c(
        "a",
        {
          staticClass: "card-footer-item",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$parent.close()
            },
          },
        },
        [_vm._v("Cancelar")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass:
            "card-footer-item has-text-danger has-text-weight-bold is-uppercase",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.deleteCert.apply(null, arguments)
            },
          },
        },
        [_vm._v("Eliminar")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-content has-text-centered" }, [
      _c("h1", { staticClass: "title is-3" }, [
        _vm._v("Eliminar copia de seguridad del certificado"),
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "subtitle is-5" }, [
        _vm._v(
          "¿Está seguro que desea eliminar la copia de seguridad del usuario?"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }